import {IConfigListar, IQueryBase} from "services-comun-ed/modules/packages/builder/interface";
import {IExpresionDynamic} from "services-comun/modules/net/checkers";
import {IPortadillaSubseccionRouter} from "../../www/interface";


// ////////////////////////////////////////////////////////////////////////////
// MySQL
// ////////////////////////////////////////////////////////////////////////////

export interface IPortadillaSubseccionMySQL {
    id_portadilla: string,
    id_dominio: string,
    orden: number,
    titulo: string,
    descripcion: string,
    url: string,
    activa: boolean,
    label: string,
}

// ////////////////////////////////////////////////////////////////////////////
// Enums Datos
// ////////////////////////////////////////////////////////////////////////////


// ////////////////////////////////////////////////////////////////////////////
// Busqueda y ordenación
// ////////////////////////////////////////////////////////////////////////////

export interface IQueryPortadillaSubsecciones extends IQueryBase {
    dominioPortadilla?: {
        dominio: string,
        id?: string,
    },
    orden?: number,
    activa?: number,
}


export interface IConfigListarPortadillaSubsecciones extends IConfigListar<IQueryPortadillaSubsecciones> {}

// ////////////////////////////////////////////////////////////////////////////
// Interfaces auxiliares
// ////////////////////////////////////////////////////////////////////////////


// ////////////////////////////////////////////////////////////////////////////
// Interfaces Comunes
// ////////////////////////////////////////////////////////////////////////////

export interface IPortadillaSubseccionResumen {
    idPortadilla: string,
    idDominio: string,
    orden: number,
    url: string,
    activa: boolean,
    label: string,
}

export interface IPortadillaSubseccion extends IPortadillaSubseccionResumen{
    titulo: string,
    descripcion: string,
}

// ////////////////////////////////////////////////////////////////////////////
// Interfaces Panel
// ////////////////////////////////////////////////////////////////////////////


// ////////////////////////////////////////////////////////////////////////////
// Interfaces Web
// ////////////////////////////////////////////////////////////////////////////

export interface IPortadillaSubseccionWeb extends IPortadillaSubseccion{
    activeTab?: boolean,
}

// ////////////////////////////////////////////////////////////////////////////
// Enumerado de tipos de respuesta
// ////////////////////////////////////////////////////////////////////////////

enum ETipoInterfazPortadillaSubseccionComun {
    Resumen = 'resumen',
    Normal = 'normal',
}
enum ETipoInterfazPortadillaSubseccionPanelPropio {
}

enum ETipoInterfazPortadillaSubseccionWebPropio {
    Router = 'router',
}

// Crear un nuevo enum que combine los valores de ambos
export const ETipoInterfazPortadillaSubseccionPanel = {
    ...ETipoInterfazPortadillaSubseccionComun,
    ...ETipoInterfazPortadillaSubseccionPanelPropio,
} as const;

export type ETipoInterfazPortadillaSubseccionPanel =
    (typeof ETipoInterfazPortadillaSubseccionPanel)[keyof typeof ETipoInterfazPortadillaSubseccionPanel];

export const ETipoInterfazPortadillaSubseccionWeb = {
    ...ETipoInterfazPortadillaSubseccionComun,
    ...ETipoInterfazPortadillaSubseccionWebPropio,
} as const;

export type ETipoInterfazPortadillaSubseccionWeb =
    (typeof ETipoInterfazPortadillaSubseccionWeb)[keyof typeof ETipoInterfazPortadillaSubseccionWeb];


export const ETipoInterfazPortadillaSubseccion = {
    ...ETipoInterfazPortadillaSubseccionComun,
    ...ETipoInterfazPortadillaSubseccionWebPropio,
    ...ETipoInterfazPortadillaSubseccionPanelPropio,
} as const;

export type ETipoInterfazPortadillaSubseccion =
    (typeof ETipoInterfazPortadillaSubseccion)[keyof typeof ETipoInterfazPortadillaSubseccion];

// ////////////////////////////////////////////////////////////////////////////
// Motivos de búsqueda
// ////////////////////////////////////////////////////////////////////////////

// ////////////////////////////////////////////////////////////////////////////
// Tipos de respuesta
// ////////////////////////////////////////////////////////////////////////////

export type IPortadillaSubseccionTypeBase = IPortadillaSubseccionResumen | IPortadillaSubseccion;
export type IPortadillaSubseccionTypeWeb = IPortadillaSubseccionTypeBase | IExpresionDynamic<IPortadillaSubseccionRouter>[] | IPortadillaSubseccionWeb;
export type IPortadillaSubseccionTypePanel = IPortadillaSubseccionTypeBase;

export type IPortadillaSubseccionType = IPortadillaSubseccionTypeWeb | IPortadillaSubseccionTypePanel;















